import { Dispatch } from 'redux';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { PayloadAction } from 'sos-common/js/commonTypes/action.types';
import { dialogueErrorBody } from 'sos-eservice-common/js/config/dialogueErrorBodies';
export const ERROR_EVENT = 'ERROR_EVENT';
export const REMOVE_ERROR_EVENT = 'REMOVE_ERROR_EVENT';
export const DIALOGUE_ERROR = 'DIALOGUE_ERROR';

export interface ErrorMessage<T extends Error = Error> {
  error: T;
  fieldName: string;
  friendlyMessage: string;
}
export type errorEventAction = PayloadAction<typeof ERROR_EVENT, ErrorMessage>;

export function errorEvent(errorMessage: ErrorMessage) {
  return {
    type: ERROR_EVENT,
    payload: errorMessage,
  } as errorEventAction;
}

export type removeErrorEventAction = PayloadAction<typeof REMOVE_ERROR_EVENT, string>;
export function removeErrorEvent(fieldName: string) {
  return {
    type: REMOVE_ERROR_EVENT,
    payload: fieldName,
  } as removeErrorEventAction;
}

export type clearError = ReturnType<typeof clearErrorDispatcher>;
export function clearErrorDispatcher(dispatch: Dispatch) {
  return function (fileField: FormFieldFile) {
    return dispatch(removeErrorEvent(fileField.fieldName));
  };
}

export type dialogueErrorAction = PayloadAction<typeof DIALOGUE_ERROR, dialogueErrorBody>;
export function dialogueError(dialogueContent: dialogueErrorBody) {
  return {
    type: DIALOGUE_ERROR,
    payload: dialogueContent,
  } as dialogueErrorAction;
}
